import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { SmtpConnection } from '@definitions/smtp/smtp-connection';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SmtpConnectionsService } from '../services/smtp-connections.service';

export const smtpConnectionResolverFn = (
	route: ActivatedRouteSnapshot
): Observable<SmtpConnection> => {
	const connectionsSvc = inject(SmtpConnectionsService);
	const connectionId = route.paramMap.get('connectionId');

	return !isNaN(connectionId as any)
		? connectionsSvc.find(connectionId).pipe(catchError(() => of(null)))
		: of(null);
};
